var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      model: {
        value: _vm.state.sortRowsModalOpen,
        callback: function ($$v) {
          _vm.$set(_vm.state, "sortRowsModalOpen", $$v)
        },
        expression: "state.sortRowsModalOpen",
      },
    },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sort-rows")))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            [
              _vm._l(_vm.items, function (item) {
                return _c(
                  "w-list-item",
                  {
                    key: item.value,
                    on: {
                      click: function ($event) {
                        return _vm.sort(item.value)
                      },
                    },
                  },
                  [_c("w-list-item-text", [_vm._v(_vm._s(item.text))])],
                  1
                )
              }),
              _vm._l(_vm.sortByExtraFieldItems, function (item) {
                return _c(
                  "w-list-item",
                  {
                    key: item.value,
                    on: {
                      click: function ($event) {
                        return _vm.sortByExtraFields(item.value)
                      },
                    },
                  },
                  [_c("w-list-item-text", [_vm._v(_vm._s(item.text))])],
                  1
                )
              }),
              _vm._l(_vm.sortByProductExtraFieldItems, function (item) {
                return _c(
                  "w-list-item",
                  {
                    key: item.value,
                    on: {
                      click: function ($event) {
                        return _vm.sortByProductExtraFields(item.value)
                      },
                    },
                  },
                  [_c("w-list-item-text", [_vm._v(_vm._s(item.text))])],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }